module.exports = __webpack_public_path__ + "img/visa.ca985897.png";